import React from 'react';

import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { BlockWrapper } from '@/features/utils/BlockWrapper';

import { DEFAULT_HR_EMAIL } from './constants';
import { JobApplicationForm } from './JobApplicationForm';
import { BlockHeaderContent } from '../utils/BlockHeaderContent';

export type JobApplicationStrapiProps = {
  hrEmail?: string;
  role: string;
};

export function JobApplicationFormStrapi({
  block,
}: BlockComponentModel<JobApplicationStrapiProps>) {
  const { hrEmail, role } = block;

  const job = { role, hrEmail: hrEmail ?? DEFAULT_HR_EMAIL };

  return (
    <BlockWrapper data-tracker-section={SECTION_NAMES.JOB_APPLICATION_FORM}>
      <BlockHeaderContent title='Submit your application' alignment='left'>
        <JobApplicationForm job={job} />
      </BlockHeaderContent>
    </BlockWrapper>
  );
}
